import { Route, Routes } from "react-router-dom";

import NotFoundPage from "components/error/NotFoundPage";
import useAssistantPanelAvailable from "hooks/useAssistantPanelAvailable";

import LaunchPadBoard from "./Board";
import LaunchPadUserGuidesGroup from "./UserGuidesGroup";

const LaunchPad = () => {
  if (!useAssistantPanelAvailable()) {
    return <LaunchPadBoard />;
  } 

  return (
    <Routes>
      <Route index element={<LaunchPadBoard />} />
      <Route path="/learn/:userGuideGroupId">
        <Route index path="*" element={<LaunchPadUserGuidesGroup />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default LaunchPad;
